(function () {
    var section = document.querySelector('[data-aa-section]');
    if (!section) return;

  /* ExtraLife 2026-09-02: міст до ES-модуля @shopify/events. Класичний скрипт не може
     робити import() напряму — мініфікатор Shopify CDN переписує його на require() і
     код падає. Тому підключаємо крихітний inline-модуль, який виставляє клас події
     у window.__elCartEvents (import map теми резолвить bare-specifier). */
  if (!window.__elCartEvents && !document.getElementById('el-cart-events-bridge')) {
    var elBridge = document.createElement('script');
    elBridge.type = 'module';
    elBridge.id = 'el-cart-events-bridge';
    elBridge.textContent = "import { CartLinesUpdateEvent } from '@shopify/events'; window.__elCartEvents = { CartLinesUpdateEvent: CartLinesUpdateEvent };";
    document.head.appendChild(elBridge);
  }

    /* ══ bundle rows: independent qty steppers, multi-item add-to-cart ══
       Each row is its own variant with its own quantity (0 = not included).
       "ДОДАТИ В КОШИК" collects every row with qty > 0 into one /cart/add.js
       call with an items[] array — a native <form> can only ever carry a
       single variant, so this always needs JS. ══ */
    var packs = section.querySelectorAll('[data-aa-pack]');
    var stickyPriceEl = section.querySelector('[data-aa-sticky-price]');
    var bundlesWrap = section.querySelector('[data-aa-bundles]');
    var stickyPriceDefault = stickyPriceEl ? stickyPriceEl.textContent.trim() : '';

    function parseMoney(text) {
      var n = parseFloat(String(text || '').replace(/\s/g, '').replace(',', '.').replace(/[^0-9.]/g, ''));
      return isNaN(n) ? 0 : n;
    }
    function formatMoney(n) {
      var rounded = Math.round(n * 100) / 100;
      var str = (rounded % 1 === 0) ? String(rounded) : rounded.toFixed(2).replace(/0$/, '').replace('.', ',');
      return str + ' ₴';
    }
    function refreshTotal() {
      var total = 0;
      packs.forEach(function (pack) {
        var valueEl = pack.querySelector('[data-aa-stepper-value]');
        var qty = valueEl ? (parseInt(valueEl.textContent, 10) || 0) : 0;
        pack.classList.toggle('aa-bundle-row--active', qty > 0);
        if (qty > 0) {
          var priceEl = pack.querySelector('[data-aa-pack-price]');
          var price = priceEl ? parseMoney(priceEl.textContent) : 0;
          total += price * qty;
        }
      });
      if (stickyPriceEl) stickyPriceEl.textContent = total > 0 ? formatMoney(total) : stickyPriceDefault;
    }

    packs.forEach(function (pack) {
      var minus = pack.querySelector('[data-aa-stepper-minus]');
      var plus = pack.querySelector('[data-aa-stepper-plus]');
      var valueEl = pack.querySelector('[data-aa-stepper-value]');
      if (!minus || !plus || !valueEl) return;
      function setQty(n) {
        n = Math.max(0, n);
        valueEl.textContent = String(n);
        minus.disabled = n === 0;
        refreshTotal();
      }
      minus.addEventListener('click', function () { setQty((parseInt(valueEl.textContent, 10) || 0) - 1); });
      plus.addEventListener('click', function () { setQty((parseInt(valueEl.textContent, 10) || 0) + 1); });
    });

    var mainForm = section.querySelector('[data-aa-atc-main]') ? section.querySelector('[data-aa-atc-main]').form : null;
    if (mainForm) {
      mainForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var items = [];
        packs.forEach(function (pack) {
          var valueEl = pack.querySelector('[data-aa-stepper-value]');
          var qty = valueEl ? (parseInt(valueEl.textContent, 10) || 0) : 0;
          if (qty > 0) {
            items.push({ id: parseInt(pack.getAttribute('data-aa-pack-variant-id'), 10), quantity: qty });
          }
        });
        var mainBtn2 = section.querySelector('[data-aa-atc-main]');
        if (!items.length) {
          if (bundlesWrap) {
            bundlesWrap.classList.add('aa-bundles--nudge');
            setTimeout(function () { bundlesWrap.classList.remove('aa-bundles--nudge'); }, 600);
            bundlesWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return;
        }
        var originalHtml = mainBtn2 ? mainBtn2.innerHTML : '';
        if (mainBtn2) { mainBtn2.disabled = true; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (result) {
            if (result.ok) {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              /* ExtraLife 2026-09-02: не переходимо на /cart — відкриваємо шухляду кошика.
   Диспатчимо той самий CartLinesUpdateEvent, що й рідний product-form теми:
   cart-items-component перемальовує шухляду, header оновлює лічильник,
   cart-drawer-component (auto-open) відкриває її. Фолбек — редірект на /cart. */
Promise.resolve(window.__elCartEvents || Promise.reject(new Error('cart events bridge not loaded'))).then(function (ev) {
  var deferred = ev.CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(new ev.CartLinesUpdateEvent({
    action: 'add', context: 'product',
    lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity }; }),
    promise: deferred.promise
  }));
  return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      deferred.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'extralife-pdp', didError: false } });
      var drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.open === 'function' && !drawer.isOpen) drawer.open();
    });
}).catch(function () { window.location.href = '/cart'; })
  .then(function () { if (mainBtn2) { mainBtn2.disabled = false; } });
            } else if (mainBtn2) {
              mainBtn2.textContent = 'Помилка, спробуй ще';
              mainBtn2.disabled = false;
              setTimeout(function () { mainBtn2.innerHTML = originalHtml; }, 2200);
            }
          })
          .catch(function () {
            if (mainBtn2) {
              mainBtn2.textContent = 'Помилка, спробуй ще';
              mainBtn2.disabled = false;
              setTimeout(function () { mainBtn2.innerHTML = originalHtml; }, 2200);
            }
          });
      });
    }

    /* sticky bar visibility — IntersectionObserver (theme scrolls inside .page-wrapper, not window) */
    var mainBtn = section.querySelector('[data-aa-atc-main]');
    var stickyBar = section.querySelector('[data-aa-sticky]');
    if (mainBtn && stickyBar && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        });
      }, { threshold: 0 });
      io.observe(mainBtn);
    }

    /* gallery */
    var thumbs = section.querySelectorAll('[data-aa-gal-thumb]');
    var slides = section.querySelectorAll('[data-aa-gal-slide]');
    var galIndices = Array.prototype.map.call(slides, function (s) { return s.getAttribute('data-aa-gal-slide'); });

    function activateGalSlide(idx) {
      thumbs.forEach(function (t) { t.classList.toggle('aa-gallery__thumbbtn--active', t.getAttribute('data-aa-gal-thumb') === idx); });
      slides.forEach(function (s) { s.classList.toggle('aa-gallery__slide--active', s.getAttribute('data-aa-gal-slide') === idx); });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateGalSlide(thumb.getAttribute('data-aa-gal-thumb'));
      });
    });

    var galPrev = section.querySelector('[data-aa-gal-prev]');
    var galNext = section.querySelector('[data-aa-gal-next]');
    function currentGalIndex() {
      var activeSlide = section.querySelector('[data-aa-gal-slide].aa-gallery__slide--active');
      var idx = activeSlide ? galIndices.indexOf(activeSlide.getAttribute('data-aa-gal-slide')) : 0;
      return idx < 0 ? 0 : idx;
    }
    function goToGalOffset(offset) {
      if (!galIndices.length) return;
      var i = currentGalIndex();
      var nextI = (i + offset + galIndices.length) % galIndices.length;
      activateGalSlide(galIndices[nextI]);
    }
    if (galPrev && galIndices.length) {
      galPrev.addEventListener('click', function () { goToGalOffset(-1); });
    }
    if (galNext && galIndices.length) {
      galNext.addEventListener('click', function () { goToGalOffset(1); });
    }

    /* swipe navigation (mobile: arrows/thumbs are hidden there, swipe is the only way to change photos) */
    var galMain = section.querySelector('[data-aa-gallery] .aa-gallery__main');
    if (galMain && galIndices.length > 1) {
      var touchStartX = 0;
      var touchStartY = 0;
      var touchTracking = false;
      galMain.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) { touchTracking = false; return; }
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchTracking = true;
      }, { passive: true });
      galMain.addEventListener('touchend', function (e) {
        if (!touchTracking) return;
        touchTracking = false;
        var touch = e.changedTouches && e.changedTouches[0];
        if (!touch) return;
        var dx = touch.clientX - touchStartX;
        var dy = touch.clientY - touchStartY;
        var SWIPE_THRESHOLD = 40;
        if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
          goToGalOffset(dx < 0 ? 1 : -1);
        }
      }, { passive: true });
    }

    /* reviews show more */
    var moreBtn = section.querySelector('[data-aa-reviews-toggle]');
    var extras = section.querySelectorAll('[data-aa-review-extra]');
    if (moreBtn && extras.length) {
      var expanded = false;
      moreBtn.addEventListener('click', function () {
        expanded = !expanded;
        extras.forEach(function (el) { el.hidden = !expanded; });
        moreBtn.textContent = expanded ? 'Сховати відгуки' : 'Показати ще відгуки';
      });
    }

    /* FAQ tabs */
    var faqTabs = section.querySelectorAll('[data-aa-faq-tab]');
    faqTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-aa-faq-tab');
        faqTabs.forEach(function (t) {
          t.classList.toggle('aa-faq__tab--active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        section.querySelectorAll('[data-aa-faq-panel]').forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-aa-faq-panel') !== target;
        });
      });
    });

    /* composition modal */
    var modal = section.querySelector('[data-aa-modal]');
    if (modal) {
      section.querySelectorAll('[data-aa-open-comp]').forEach(function (btn) {
        btn.addEventListener('click', function () { modal.hidden = false; document.documentElement.style.overflow = 'hidden'; });
      });
      modal.querySelectorAll('[data-aa-modal-close]').forEach(function (el) {
        el.addEventListener('click', function () { modal.hidden = true; document.documentElement.style.overflow = ''; });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) { modal.hidden = true; document.documentElement.style.overflow = ''; }
      });
    }
  })();
